<template>
    <b-container class="footer" fluid>
        <b-row>
            <b-col>
                <p class="h5 mb-4">
                    <strong>About</strong>
                </p>
                <div class="my-2"><a href="#" class="text-muted">About Gozhere</a></div>
                <div class="my-2"><a href="#" class="text-muted">Careers</a></div>
                <div class="my-2"><a href="#" class="text-muted">Press</a></div>
                <div class="my-2"><a href="#" class="text-muted">Investor Relations</a></div>
                <div class="my-2"><a href="#" class="text-muted">Content Guidelines</a></div>
                <div class="my-2"><a href="#" class="text-muted">Terms of Service</a></div>
                <div class="my-2"><a href="#" class="text-muted">Privacy Policy</a></div>
                <div class="my-2"><a href="#" class="text-muted">Ad Choices</a></div>
            </b-col>
            <b-col>
                <p class="h5 mb-4">
                    <strong>Discover</strong>
                </p>
                <div class="my-2"><a href="#" class="text-muted">Collections</a></div>
                <div class="my-2"><a href="#" class="text-muted">Miniapps</a></div>
                <div class="my-2"><a href="#" class="text-muted">Minishops</a></div>
                <div class="my-2"><a href="#" class="text-muted">Gozhere Blog</a></div>
                <div class="my-2"><a href="#" class="text-muted">Support</a></div>
                <div class="my-2"><a href="#" class="text-muted">Gozhere Mobile</a></div>
                <div class="my-2"><a href="#" class="text-muted">Developers</a></div>
            </b-col>
            <b-col>
                <p class="h5 mb-4">
                    <strong>Gozhere for Business</strong>
                </p>
                <div class="my-2"><a href="#" class="text-muted">Claim your Business Page</a></div>
                <div class="my-2"><a href="#" class="text-muted">Advertise on Gozhere</a></div>
                <div class="my-2"><a href="#" class="text-muted">Gozhere for Restaurant Owners</a></div>
                <div class="my-2"><a href="#" class="text-muted">Table Management</a></div>
                <div class="my-2"><a href="#" class="text-muted">Business Success Stories</a></div>
                <div class="my-2"><a href="#" class="text-muted">Business Support</a></div>
                <div class="my-2"><a href="#" class="text-muted">Gozhere Blog for Business</a></div>
            </b-col>
        </b-row>
        <b-row class="my-5">
            <b-col>
                <div class="text-muted">
                    Copyright © 2021 Gozhere.
                </div>
            </b-col>
        </b-row>
        <b-row/>
    </b-container>
</template>

<style scoped>
.footer {
    background-color: #F5F5F5;
    padding-top: 50px;
    padding-left: 400px;
    padding-right: 400px;
}
</style>

<script>
export default {
    
}
</script>